import { render, staticRenderFns } from "./number-roller.vue?vue&type=template&id=6f71b870"
import script from "./number-roller.vue?vue&type=script&lang=js"
export * from "./number-roller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports